import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AppComponent} from './app.component';
import { WebShareComponent } from './web-share/web-share.component';
import { from } from 'rxjs';
const routes: Routes = [
  { path: '', component: AppComponent,
    children: [

      { path: 'event/:productType/:productID/:referID/:parent_product', component: WebShareComponent,  data: {
        screen_name: 'web-share',module_name:'web-share'} },

        { path: 'event/:productType/:productID/:referID', component: WebShareComponent,  data: {
          screen_name: 'web-share',module_name:'web-share'} },

          
      { path: ':productType/:productID', component: WebShareComponent,  data: {
        screen_name: 'web-share',module_name:'web-share'} },

      { path: ':productType/:productID/:referID', component: WebShareComponent,  data: {
        screen_name: 'web-share',module_name:'web-share'} },

        { path: ':productType/:productID/:referID/:parent_product', component: WebShareComponent,  data: {
          screen_name: 'web-share',module_name:'web-share'} },


      
    ] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule 
{
  
 }
